import { useMemo } from "react";
import { createNestedTreeFromTree } from "../helpers/tree.helpers";
import { useTree } from "./use-tree.hook";
import { NodeMap } from "src/types/node.types";
import type { CanvasPositionMap } from "src/features/editor";

export function useNestedTree(positions: CanvasPositionMap, nodes: NodeMap) {
  const tree = useTree(positions, nodes);
  return useMemo(() => createNestedTreeFromTree(tree), [tree]);
}
